
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import { UserConfigService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			shouldExpand: false
		};
	},
	props: {
		title: [String, Object as () => {toString():string}],
		sending: Boolean
	},
	methods: {
		close() {
			this.$emit("close");
		},
		toggleExpand(){
			this.shouldExpand = !this.shouldExpand;
			let settings = UserConfigService.getGeneralSettings();
			settings.MaximizeEmailModal = this.shouldExpand;
			UserConfigService.setGeneralSettings(settings);
		}
	},
	created(){
		this.shouldExpand = UserConfigService.getGeneralSettings().MaximizeEmailModal;
	},
	components: {
		AppMobileFullScreenContainer,
	}
});
